<template>
  <div class="pt-sm-3">
    <b-col cols="12">
      <PageTitle title="Mudar a cor e sobre" />
    </b-col>
    <b-col cols="12">
      <b-row>
        <b-col cols="12" class="form-group">
          <label class="font-weight-bold">Sobre</label>
          <ckeditor
            v-model="fields.about"
            :editor="editorSettings.type"
            :config="editorSettings.config"
          />
        </b-col>
    
        <b-col cols="12" class="my-3">
          <h4 class="text-center">Customização do site</h4>
        </b-col>
        
        <b-col cols="12">
          <b-row>
            <b-col cols="12" lg="6" class="mt-5">
              <FakeWebProfessional
                style="min-height: 400px; max-height: 400px; height: 400px; margin-bottom: 120px;"
                :primary-color="fields.primaryColor.hex8"
                :header-menu-color="fields.headerColor.hex8"
                :footer-color="fields.footerColor.hex8"
                :font-color="fields.fontColor.hex8"
                :icon-color="fields.iconColor.hex8"
                :background-color="fields.backgroundColor.hex8"
                :about="fields.about"
              />
            </b-col>

            <b-col cols="12" lg="6">
              <b-row>
                <b-col class="mt-3">
                  <label>Cor principal</label>
                  <chrome-picker v-model="fields.primaryColor" />
                </b-col>
                <b-col class="mt-3">
                  <label>Cor do cabeçalho</label>
                  <chrome-picker v-model="fields.headerColor" />
                </b-col>
                <b-col class="mt-3">
                  <label>Cor do rodapé</label>
                  <chrome-picker v-model="fields.footerColor" />
                </b-col>
                <b-col class="mt-3">
                  <label>Cor das fontes</label>
                  <chrome-picker v-model="fields.fontColor" />
                </b-col>
                <b-col class="mt-3">
                  <label>Cor dos ícones</label>
                  <chrome-picker v-model="fields.iconColor" />
                </b-col>
                <b-col class="mt-3">
                  <label>Cor do fundo</label>
                  <chrome-picker v-model="fields.backgroundColor" />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
        
        <b-col cols="12" class="mt-4 mb-4">
          <div class="saveButton">
            <b-button block  variant="success" @click="save()">
              <i class="fas fa-save mr-2"></i>
              <span>Salvar</span>
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </div>
</template>

<script>
import { Chrome } from 'vue-color';

import { mapActions, mapState } from 'vuex';
import makeToast from '@/mixins/makeToast';
import PageTitle from '@/components/PageTitle.vue';
import FakeWebProfessional from '@/views/lojista/customizations/ChangeColor/FakeWebProfessional.vue';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import UploadAdapter from '@/utils/UploadAdapterAxios.js';

const UploadAdapterPlugin = (editor) => {
  editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
    const token = localStorage.getItem('token');
    return new UploadAdapter(loader, token);
  };
};

export default {
  name: 'ChangeColor',
  components: { PageTitle, FakeWebProfessional, 'chrome-picker': Chrome },
  mixins: [makeToast],
  data() {
    return {
      loading: false,
      fields: {
        about: '',
        primaryColor: {},
        headerColor: {},
        footerColor: {},
        fontColor: {},
        iconColor: {},
        backgroundColor: {},
      },
      editorSettings: {
        type: ClassicEditor,
        config: {
          extraPlugins: [UploadAdapterPlugin],
        },
      },
    };
  },
  computed: {
    ...mapState(['dadosUsuario']),
  },
  mounted() {
    this.get();
  },
  methods: {
    ...mapActions('professional', ['saveCustomization', 'getCustomization']),
    get() {
      this.$store.dispatch('startLoader');
      this.loading = true;

      this.getCustomization(this.dadosUsuario.informacoes.id)
        .then((response) => {
          if (!response.data.data) return;

          this.fields.about = response.data.data.about;
          this.handleColors(response.data.data);
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.loading = false;
        });
    },
    save() {
      const request = {
        professionalId: this.dadosUsuario.informacoes.id,
        about: this.fields.about || '',
      };

      Object.keys(this.fields).forEach((key) => {
        if (!key.includes('Color')) return;

        request[key] = this.fields[key].hex8;
      });

      this.$store.dispatch('startLoader');

      this.saveCustomization(request)
        .then(() => {
          this.makeToast('Sucesso', 'Cores salvas com sucesso');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    handleColors({
      primaryColor,
      headerColor,
      footerColor,
      fontColor,
      iconColor,
      backgroundColor,
    }) {
      this.$set(this.fields.primaryColor, 'hex8', primaryColor);
      this.$set(this.fields.primaryColor, 'hex', primaryColor);

      this.$set(this.fields.headerColor, 'hex8', headerColor);
      this.$set(this.fields.headerColor, 'hex', headerColor);

      this.$set(this.fields.footerColor, 'hex8', footerColor);
      this.$set(this.fields.footerColor, 'hex', footerColor);

      this.$set(this.fields.fontColor, 'hex8', fontColor);
      this.$set(this.fields.fontColor, 'hex', fontColor);

      this.$set(this.fields.iconColor, 'hex8', iconColor);
      this.$set(this.fields.iconColor, 'hex', iconColor);

      this.$set(this.fields.backgroundColor, 'hex8', backgroundColor);
      this.$set(this.fields.backgroundColor, 'hex', backgroundColor);
    },
  },
};
</script>

<style scoped>
.b-width {
  width: 90%;
  margin-left: x;
}

@media (min-width: 768px) {
  .saveButton {
    display: flex;
    height: 50px;
  }
}
</style>
